import { get, post } from './http-calls';

export const addPortalSettings = async (data) => {
    let res = await post('PortalSetting', data, { useAuthToken: true });
    return res;
};

export const getPortalSettings = async () => {
    let res = await get(`PortalSetting`, { useAuthToken: true });
    return res;
};

export const getOcrDocumentsListById = async (id) => {
    let res = await get(`OCRDocument/OcrDocumentsList/ByProcessID?Id=1`, { useAuthToken: true });
    return res;
};

export const addGraphMailSettings = async (data) => {
    let res = await post('PortalSetting/GraphMailSettings_AddUpdate', data, { useAuthToken: true });
    return res;
};

export const getGraphMailSettings = async () => {
    let res = await get('PortalSetting/Get_GraphMailSettings', { useAuthToken: true });
    return res;
};
